import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const totalAmount: SugarElementInfo = {
    name: "totalAmount",
    availableChildren: { type: AvailableChildrenType.Any },
};
